"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _miniBagConfigurationContext = require("./miniBagConfigurationContext");
Object.keys(_miniBagConfigurationContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _miniBagConfigurationContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _miniBagConfigurationContext[key];
    }
  });
});
